import slug from 'slug';

export function generateCode(codeLen: number): string {
  return Math.random()
    .toString(36)
    .substring(2, codeLen + 2)
    .toUpperCase();
}

export const pluralize = (
  n: number | null | undefined,
  single: string,
  plural: string,
  showCount = true
): string => {
  const count = n ?? 0;
  const word = count > 1 ? plural : single;

  return showCount ? `${count} ${word}` : word;
};

export const slugify = (str: string): string => slug(str, { lower: true });

export const upperCaseFirstLetter = (string: string): string =>
  string.charAt(0).toUpperCase() + string.slice(1);

export const toSnakeCase = (string?: string): string => {
  if (!string) {
    return '';
  }

  return (
    string.charAt(0).toLowerCase() +
    string.slice(1).replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`)
  );
};

export const formatCurrency = (
  price: number,
  currency?: string,
  defaultText = ''
): string => {
  const intlConfig: Intl.NumberFormatOptions = {
    currency,
    style: currency ? 'currency' : undefined,
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  };

  if (!currency) {
    return price.toFixed(2);
  }

  return typeof price === 'number'
    ? new Intl.NumberFormat('en-US', intlConfig).format(price)
    : defaultText;
};
